import React , {Component} from 'react'
import { Row, Col , Icon} from 'antd';
import { Link} from "react-router-dom";
import MainLayout from "../../layouts/mainLayout";


export default class InDevelopment extends Component{
    constructor(props){
        super(props);

    }
    render(){
        return(
            <MainLayout>

                <div className={"indevelopmentWrapper"}>
                    <div className="indevpageWrapper">
                    <div className="container">
                        <div className="indevelopment">
                            <Row className={"indevelopmentRow"}>
                                <Col xs={22} sm={22} md={18} lg={12} xl={12}>
                                    <div className="InDevelopmentCard">
                                        <div className="inDevText">
                                            <div className="indevTop">
                                                <img src="clientAssets/vintage.png" alt=""/>
                                            </div>
                                            <p>این بخش از سامانه در حال توسعه و به روزرسانی ‌می‌باشد</p>
                                            <div className="indevBottom">
                                                <img src="clientAssets/vintage.png" alt=""/>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
                </div>
            </MainLayout>
        )
    }
}
